<template>
  <div class="wrapper">
   <div class="body-area pb-0">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12 p-0 succes-top">
          </div>
          <div class="col-12 text-center py-2 succes-bottom ">
            <div>
            <h1 class="fs-22 fc-2">TEBRİKLER!</h1>
            <h2 class="fs-18 fc-2 font-weight-normal"> Galatasaray Doğa Sigorta maçına check-in yaparak 30 puan kazandın.</h2>
            <h3 class="fs-14 fc-2 font-weight-bold">Kalan Puanın: 999,999</h3>
            <router-link :to="{ name: 'Home' }" style="display:block;" class="ignore-button mt-2">Anasayfaya Dön</router-link></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Menu from "@/components/Menu";
export default {
  name: "CheckInSuccess",
  components: {
    Footer,
    Menu,
    Header
  }
};
</script>


// WEBPACK FOOTER //
// src/pages/CheckInSuccess.vue